import { gql } from "@apollo/client";

export const FETCH_INVITE_LINK = gql`
    query InviteLink($code: String!) {
        inviteLink(code: $code) {
            id
            email
            role
            companyId
            company {
                name
            }
            isUsed
        }
    }
`;